import { Pipe, PipeTransform } from '@angular/core';
import { KeyValuePipe, KeyValue } from '@angular/common';

interface IKeyValue {
  key: string;
  value: string;
}

@Pipe({
  name: 'orderedKeyValue',
})
export class OrderedKeyValue implements PipeTransform {
  constructor(private keyValuePipe: KeyValuePipe) { }

  public transform(value: Map<string, string>): IKeyValue[] {
    const orderFn = (_a: KeyValue<string, string>, _b: KeyValue<string, string>) => 0;

    return this.keyValuePipe.transform(value, orderFn);
  }
}
